export var AuthTypes;
(function (AuthTypes) {
    let AuthSteps;
    (function (AuthSteps) {
        AuthSteps["AUTH_1"] = "EmailInput";
        AuthSteps["AUTH_2"] = "OTPInput";
        AuthSteps["BLOCKED"] = "BlockedStatus";
    })(AuthSteps = AuthTypes.AuthSteps || (AuthTypes.AuthSteps = {}));
})(AuthTypes || (AuthTypes = {}));
